module.exports = __webpack_public_path__ + "img/5.1666677a.jpg";